import { combineReducers } from "redux";
import { generalReducer } from "./components/reducer";
import { Action as AuthenticationAction } from "src/components/authorization-gate/authorization-gate-store";
import { itkComponentsReducer } from "@itk/mui-components";
import { pageReducer } from "./pages/reducer";
import { hooksReducer } from "./hooks/reducer";
import { deleteAllCache } from "./utils/cache-utils";

const appReducer = combineReducers({ generalReducer, itkComponentsReducer, pageReducer, hooksReducer });

type Params = Parameters<typeof appReducer>;

export const rootReducer = (state: Params[0], action: Params[1]) => {
  if (action.type === AuthenticationAction.LogoutSuccess) {
    localStorage.clear();
    deleteAllCache();
    window.location.reload();
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
